module.exports = __webpack_public_path__ + "media/AdminResoldCustomers.bbd97c8119e9e6ab8c15689c36803167.svg";